export const ModelSlugs = 'modelle';

export function getModelListUrl(dealerSlug?: string): string {
    return `/${dealerSlug ? `${dealerSlug}/` : ''}${ModelSlugs}`;
}

export function getModelDetailUrl(dealerSlug: string, modelSlug: string): string {
    return `/${dealerSlug}/${ModelSlugs}/${modelSlug}`;
}
